'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minuteBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/minuteBefore.js
// module id = 185
// module chunks = 0